import { render, staticRenderFns } from "./corneaOrder.vue?vue&type=template&id=d24f5ab2&scoped=true&"
import script from "./corneaOrder.vue?vue&type=script&lang=js&"
export * from "./corneaOrder.vue?vue&type=script&lang=js&"
import style0 from "./corneaOrder.vue?vue&type=style&index=0&id=d24f5ab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24f5ab2",
  null
  
)

export default component.exports